export const loadingReducerSelector = state => state.loadingReducer;
